export const stepperIds = { root: 'stepper' }

export const stepperDimensions = {
  height: 56,
}
